import { fg } from '@atlassian/jira-feature-gating';

import {
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';

import { createSemanticModelResource } from './createSemanticModelResource.tsx';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const assetsDashboardsSemanticModelResource: RouteResource<any> =
	createSemanticModelResource({
		hostingProduct: 'jsm-cmdb',
		location: 'assets',
		products: () =>
			fg('platform_avp_enable_jira_confluence_for_assets')
				? ['jira', 'jsm-cmdb', 'confluence']
				: ['jsm-cmdb'],
		subProducts: () => (fg('platform_avp_enable_jira_confluence_for_assets') ? ['jsm', 'csm'] : []),
		// Assets dashboards want `jsm-cmdb` first; rest follow the AVP default
		// order (mirrors the legacy list in `metricField.tsx`). Only applied
		// when `platform_avp_metric_sorting` is ON — see
		// `fetchAvpSemanticModel.tsx`.
		desiredOrder: ['jsm-cmdb', 'jira', 'goals', 'devops', 'xray'],
	});

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const useAssetsDashboardsSemanticModel = (): UseResourceHookResponse<any> =>
	useResource(assetsDashboardsSemanticModelResource);
